import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  TableRow,
  TableCell,
} from '@material-ui/core';

class EcommDataReadOnlyRow extends Component {
  render() {
    const {
      key,
      title,
      valueToDisplay,
    } = this.props;
    return(
      <TableRow>
        <TableCell key={`${key}-${title}`} className="ecommTableLabel">
          <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
            {title}
          </Box>
        </TableCell>
        <TableCell key={`${key}-value`} className="studioDataRight">
          <Box className="studioDataRight studioDataNoInput">
            {valueToDisplay}
          </Box>
        </TableCell>
      </TableRow>
    )
  }
}

EcommDataReadOnlyRow.defaultProps = {
  key: 'read-only',
}

EcommDataReadOnlyRow.propTypes = {
  key: PropTypes.string,
  title: PropTypes.string.isRequired,
  valueToDisplay: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

export default EcommDataReadOnlyRow;
